import type { Normalizer } from '../format'

export class CamelCaseNormalizer implements Normalizer {
  matches(input: string) {
    const hasWhiteSpace = /\s/.test(input)
    const hasUppercase = /[A-Z]/.test(input)
    const hasLowercase = /[a-z]/.test(input)

    return !hasWhiteSpace && hasUppercase && hasLowercase
  }

  normalize(input: string) {
    const parts: string[] = []
    let part = ''

    for (let i = 0; i < input.length; i++) {
      const char = input[i]

      if (char.toUpperCase() === char) {
        if (part.length > 0) {
          parts.push(part)
        }

        part = char.toLowerCase()

        continue
      }

      part += char
    }

    if (part.length > 0) {
      parts.push(part)
    }

    return parts
  }
}
